import React, { forwardRef } from 'react';

/**
 * APEX Design System — Textarea
 *
 * Zone de texte multi-lignes avec compteur de caractères optionnel.
 *
 * Props:
 *   - label    : label
 *   - hint     : texte d'aide
 *   - error    : message d'erreur
 *   - maxLength: limite caractères + affiche compteur
 *   - rows     : nombre de lignes (default 3)
 *
 * Usage:
 *   <Textarea
 *     label="Notes"
 *     value={notes}
 *     onChange={(e) => setNotes(e.target.value)}
 *     maxLength={500}
 *     placeholder="Notes sur la session..."
 *   />
 */

const Textarea = forwardRef(function Textarea({
  label,
  hint,
  error,
  maxLength,
  rows = 3,
  value = '',
  className = '',
  ...rest
}, ref) {
  return (
    <div className={`space-y-1.5 ${className}`}>
      {label && (
        <label className="block text-[10px] tracking-[0.3em] uppercase text-zinc-500 font-semibold">
          {label}
        </label>
      )}
      <textarea
        ref={ref}
        value={value}
        maxLength={maxLength}
        rows={rows}
        className={`
          w-full bg-zinc-900 border
          ${error ? 'border-rose-400' : 'border-zinc-800 focus:border-cyan-400'}
          text-white p-2.5
          font-mono text-sm
          focus:outline-none transition resize-none
          placeholder:text-zinc-600
          disabled:opacity-40 disabled:cursor-not-allowed
        `}
        {...rest}
      />
      <div className="flex items-center justify-between gap-2">
        <div className={`text-[10px] font-mono ${error ? 'text-rose-400' : 'text-zinc-500'}`}>
          {error || hint || ' '}
        </div>
        {maxLength && (
          <div className="text-[9px] text-zinc-600 font-mono shrink-0">
            {value.length}/{maxLength}
          </div>
        )}
      </div>
    </div>
  );
});

export default Textarea;
